import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, LoadingContent, TextArea } from '../../../components'
import PdcaLayout from '../base/pdcaLayout'
import PdcaPageHeader from '../components/pdcapageheader/pdcapageheader'
import {
  clearStrategicContext,
  fetchStrategicContext,
  saveStrategicContext,
  updateStrategicContextField
} from './redux/strategiccontextActions'
import './strategiccontext.scss'

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const {
    projetoId,
    empresaPdcaExiste,
    contextoCarregado
  } = useSelector(state => state.pdcaState.pdcaBaseState)

  const {
    posicionamento = '',
    restricoes = '',
    prioridades = '',
    loading = false,
    saving = false,
    error = null
  } = useSelector(state => state.pdcaState.pdcaStrategicContextState || {})

  const contextoValido =
    contextoCarregado &&
    String(projetoId) === String(idProjetos)

  useEffect(() => {
    return () => {
      dispatch(clearStrategicContext())
    }
  }, [dispatch])

  useEffect(() => {
    if (!idProjetos || !contextoValido || !empresaPdcaExiste) return

    dispatch(fetchStrategicContext(idProjetos))
  }, [
    dispatch,
    idProjetos,
    contextoValido,
    empresaPdcaExiste
  ])

  const contextoInconsistente = contextoCarregado && !empresaPdcaExiste

  const handleChange = campo => e => {
    const valor = e?.target?.value ?? e?.value ?? ''
    dispatch(updateStrategicContextField(campo, valor))
  }

  const handleConfirmar = () => {
    dispatch(saveStrategicContext({
      projetoId: idProjetos,
      posicionamento,
      restricoes,
      prioridades
    }))
  }

  return (
    <PdcaLayout>
      <div className='box-pdca-strategiccontext'>
        <PdcaPageHeader
          title={nls.pageTitle}
        />

        {contextoInconsistente && (
          <div className='box-pdca-strategiccontext-inline-error'>
            {nls.contextError}
          </div>
        )}

        {!contextoInconsistente && (
          <LoadingContent loading={loading}>
            {error && (
              <div className='box-pdca-strategiccontext-inline-error'>
                {error || nls.loadError}
              </div>
            )}

            {!error && (
              <div className='box-pdca-strategiccontext-content'>
                <div className='box-pdca-strategiccontext-field'>
                  <div className='box-pdca-strategiccontext-label'>
                    {nls.fieldPositioning}
                  </div>
                  <TextArea
                    name='posicionamento'
                    value={posicionamento}
                    action={handleChange('posicionamento')}
                    maxLength={500}
                    disabled={saving}
                  />
                </div>

                <div className='box-pdca-strategiccontext-field'>
                  <div className='box-pdca-strategiccontext-label'>
                    {nls.fieldRestrictions}
                  </div>
                  <TextArea
                    name='restricoes'
                    value={restricoes}
                    action={handleChange('restricoes')}
                    maxLength={500}
                    disabled={saving}
                  />
                </div>

                <div className='box-pdca-strategiccontext-field'>
                  <div className='box-pdca-strategiccontext-label'>
                    {nls.fieldPriorities}
                  </div>
                  <TextArea
                    name='prioridades'
                    value={prioridades}
                    action={handleChange('prioridades')}
                    maxLength={500}
                    disabled={saving}
                  />
                </div>

                <div className='box-pdca-strategiccontext-actions'>
                  <Button
                    color='default'
                    onClick={handleConfirmar}
                    disabled={saving}
                  >
                    {saving ? nls.saving : nls.confirm}
                  </Button>
                </div>
              </div>
            )}
          </LoadingContent>
        )}
      </div>
    </PdcaLayout>
  )
}